export default function () {
  return {
    requestHealthCard: undefined,
    showRequestAcceptedDialog: false,
    showRequestPartiallyAcceptedDialog: false,
    showRequestDeniedDialog: false,
    digitalInsuranceCardInformation: undefined,
  };
}
